<template>
  <component-wrapper class="newsroom-page-fi">
    <grid-container-fi class="newsroom-page-fi__grid-container">
      <div class="newsroom-page-fi__headlines">
        <headline-fi
          v-if="fields.subheadline?.value"
          class="newsroom-page-fi__subheadline"
          tag="h2"
          :size="30"
        >
          {{ fields.subheadline.value }}
        </headline-fi>
        <headline-fi
          v-if="fields.headline?.value"
          class="newsroom-page-fi__headline"
          tag="h1"
          :size="60"
        >
          {{ fields.headline.value }}
        </headline-fi>
      </div>
      <div class="newsroom-page-fi__latest-news-container">
        <div class="newsroom-page-fi__latest-news-header">
          <headline-fi
            v-if="fields.headlineLatestNews?.value"
            class="newsroom-page-fi__headline-latest-news"
            tag="h2"
            :size="30"
          >
            {{ fields.headlineLatestNews.value }}
          </headline-fi>
          <link-fi
            v-if="newsPageUrl"
            class="newsroom-page-fi__all-news-link"
            :href="newsPageUrl"
            :size="18"
            :target="fields?.newsPageLink?.value?.target"
          >
            {{ newsPageText }}
          </link-fi>
        </div>

        <latest-news-fi />
      </div>
      <div class="newsroom-page-fi__tiles">
        <a
          v-if="medialibraryUrl"
          class="newsroom-page-fi__tile"
          :href="medialibraryUrl"
        >
          <cloud-image-fi
            v-if="fields.medialibraryImage?.value?.src"
            class="newsroom-page-fi__media"
            :src="fields.medialibraryImage?.value?.src"
            :alt="medialibraryLink?.text"
            params="func=cropfit&bg_color=black&h=290"
          />

          <div class="newsroom-page-fi__link-container">
            <link-fi
              class="newsroom-page-fi__link"
              :size="18"
              target="_blank"
            >
              {{ medialibraryLink?.text }}
            </link-fi>
          </div>
        </a>

        <a
          v-if="podcastUrl"
          class="newsroom-page-fi__tile"
          :href="podcastUrl"
        >
          <cloud-image-fi
            v-if="fields.podcastImage?.value?.src"
            class="newsroom-page-fi__media"
            :src="fields.podcastImage?.value?.src"
            :alt="podcastLink?.text"
            params="func=cropfit&bg_color=black&h=290"
          />

          <div class="newsroom-page-fi__link-container">
            <link-fi
              class="newsroom-page-fi__link"
              :size="18"
              target="_blank"
            >
              {{ podcastLink?.text }}
            </link-fi>
          </div>
        </a>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script>
import { CloudImageFi, HeadlineFi, LinkFi } from 'atoms';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import LatestNewsFi from 'components/latest-news-fi/LatestNewsFi';

export default {
  name: 'NewsroomPageFi',
  components: {
    HeadlineFi,
    ComponentWrapper,
    GridContainerFi,
    LatestNewsFi,
    LinkFi,
    CloudImageFi,
  },
  inject: ['fields'],
  computed: {
    newsPageUrl() {
      return this.fields?.newsPageLink?.value?.href || this.fields?.newsPageLink?.value?.url;
    },
    newsPageText() {
      return this.fields?.newsPageLink?.value?.text;
    },
    medialibraryLink() {
      return this.fields?.medialibraryLink?.value;
    },
    podcastLink() {
      return this.fields?.podcastLink?.value;
    },
    medialibraryUrl() {
      return this.medialibraryLink?.href || this.medialibraryLink?.url;
    },
    podcastUrl() {
      return this.podcastLink?.href || this.podcastLink?.url;
    },
  },
};
</script>

<style lang="scss">
@import './newsroom-page-fi-unscoped';
</style>

<style scoped lang="scss">
@import './newsroom-page-fi';
</style>
